export default {
    // Меню
    menu: {
        statistics: "Статистика",
        workers: "Воркеры",
        wallet: "Кошелёк",
        settings: "Настройки",
        rating: "Рейтинг",
        referral: "Реферальная программа",
        documents: "Документы",
        logout: "Выйти",
        language: "Язык",
    },

    // Авторизация
    login: {
        email: "Email",
        password: "Пароль",
        remember: "Запомнить на 30 дней",
        signin: "Войти",
        forgot: "Забыли пароль?",
        noAccount: "Нет аккаунта?",
        createAccount: "Создать аккаунт",
        emailNotVerified: "Email не подтвержден",
        sendVerifyCode: "Получить код на почту",
        goToVerify: "Ввести код подтверждения",
    },

    verifyEmail: {
        title: "Подтверждение Email",
        sendCode: "Отправить код",
        codeSent: "Код отправлен на почту",
        confirm: "Подтвердить",
        backToLogin: "Войти",
    },

    // Регистрация
    registration: {
        email: "Email*",
        referral: "Реферальный ID",
        password: "Пароль*",
        passwordConfirm: "Подтверждение пароля*",
        accountName: "Имя аккаунта",
        next: "Далее",
        emailVerification: "Подтверждение Email",
        createAccount: "Создать аккаунт",
        suspended: "Регистрация временно приостановлена",
        registerTitle: "Зарегистрировать новый аккаунт",
        alreadyAccount: "Уже есть аккаунт?",
        signIn: "Войти",
    },

    // Восстановление пароля
    restore: {
        email: "Email*",
        next: "Далее",
        securityVerification: "Проверка безопасности",
        resendCode: "Выслать код повторно",
        resendCodeSent: "Код выслан повторно",
        newPassword: "Новый пароль*",
        confirmPassword: "Подтверждение пароля*",
        changePassword: "Изменить пароль",
        title: "Восстановить пароль",
        noAccount: "Нет аккаунта?",
        createAccount: "Создать аккаунт",
    },

    // Страница приветствия
    welcome: {
        title: "Добро пожаловать!",
        subtitle: "Готовы к заработку?",
        start: "Начать!",
    },

    // Настройки
    settings: {
        title: "Настройки",
        security: "Безопасность",
        password: "Пароль",
        change: "Изменить",
        email: "Email",
        attachment: "Привязка",
        verified: "Подтверждён",
        attach: "Привязать",
        notifications: "Уведомления",
        twoFactor: "Двухфакторная аутентификация",
        usedForSecurity: "Используется для уведомлений и изменений безопасности",
        usedForWithdrawals: "Используется для выводов и изменений безопасности",
        telegramBot: "Telegram Bot",
        financialOperations: "Финансовые операции",
        miningPayout: "Выплата за майнинг",
        miningRewards: "Награды за майнинг",
        walletWithdrawal: "Вывод с кошелька",
        miningStatuses: "Статусы майнинга",
        onlineOfflineWorker: "Воркер онлайн/офлайн",
        dropHashrate: "Падение хешрейта",
        miningPools: "Майнинг пулы",
        save: "Сохранить",
        watcherLinks: "Ссылки наблюдателей",
        addWatcher: "Добавить наблюдателя",
        permission: "Разрешение",
        url: "URL",
        inputWLName: "Введите имя WL",
        autoSwap: "Авто-обмен",
        autoSwaps: "Авто-обмены",
        enableAutoSwap: "Включить авто-обмен",
        enableAutoPayout: "Включить авто-выплату",
        disableAutoPayout: "Авто-выплата отключена",
        autoPayoutEnabled: "Авто-выплата включена: минимум {min} BTC на адрес {wallet}",
        payouts: "Выплаты",
        minimumValue: "Минимальное значение",
        address: "Адрес",
        enterBTCWallet: "Введите адрес BTC кошелька",
        enterWalletAddress: "Введите адрес кошелька",
        selectNetwork: "Выбрать сеть",
        oldPassword: "Старый пароль*",
        newPassword: "Новый пароль*",
        changePassword: "Изменить пароль",
        passwordConfirm: "Подтверждение пароля*",
        watcherName: "Имя",
        watcherTags: "Теги",
        watcherWorkers: "Воркеры",
        watcherTransactions: "Транзакции",
        watcherBalance: "Баланс",
        watcherHashrate: "Хешрейт",
        watcherDelete: "УДЛ",
        watcherLogin: "Логин",
        mail: "Почта",
        tg: "TG",
        legal: {
            title: "Реквизиты юридического лица",
            desc: "Реквизиты, телефон, адрес зачисления и watcher подставляются в отчёт о майнинге.",
            legalName: "Наименование организации / ИП",
            inn: "ИНН",
            kpp: "КПП",
            ogrn: "ОГРН / ОГРНИП",
            legalAddress: "Юридический адрес",
            phone: "Номер телефона",
            creditAddress: "Адрес-идентификатор",
            watcher: "Watcher-link",
            bankAccount: "Расчётный счёт",
            bankBik: "БИК банка",
            bankName: "Наименование банка",
            ph_legalName: "ООО «Ромашка» / ИП Иванов И.И.",
            ph_inn: "7700000000",
            ph_kpp: "770001001",
            ph_ogrn: "1027700000000",
            ph_legalAddress: "г. Москва, ул. Примерная, д. 1",
            ph_phone: "+79991234567",
            ph_creditAddress: "bc1q...",
            ph_watcher: "https://...",
            ph_bankAccount: "40702810000000000000",
            ph_bankBik: "044525225",
            ph_bankName: "ПАО Сбербанк",
            saved: "Сохранено",
            saving: "Сохраняется...",
            error: "Ошибка при сохранении. Попробуйте снова.",
            err_inn: "ИНН должен содержать 10 или 12 цифр",
            err_bik: "БИК должен содержать ровно 9 цифр",
            err_account: "Расчётный счёт должен содержать ровно 20 цифр",
            err_kpp: "КПП должен содержать ровно 9 цифр",
            err_phone: "Телефон: от 5 символов, цифры, +, пробел, скобки или дефис",
        },
    },

    // Воркеры
    workers: {
        title: "Воркеры",
        total: "Всего",
        global: "Глобально",
        hashrate: "Хешрейт",
        chart: "График",
        tags: "Теги",
        set: "Установить",
        setHashrate: "Установить хешрейт",
        extraInfo: "Дополнительная информация",
        reportTitle: "Дополнительная информация",
        reportBrand: "Марка оборудования",
        reportModel: "Модель оборудования",
        reportSerial: "Заводской номер",
        reportHours: "Часы в эксплуатации",
        reportStratumHours: "Часы по стратуму",
        reportSave: "Сохранить",
        reportSaving: "Сохраняется...",
        reportSaved: "Сохранено",
        reportError: "Не удалось сохранить",
        addDevice: "Добавить устройство",
        delete: "Удалить",
        deleteWorker: "Удалить воркер",
        deleteConfirm: "Это действие удалит все данные выбранного воркера",
        addFirstDevice: "Добавьте первое устройство здесь",
        orHere: "Или здесь",
        connectingWorker: "Подключение нового воркера",
        workerConfig: "Конфигурация воркера",
        customizeName: "Настройте имя воркера",
        stratumConfig: "Настройте конфигурацию стратума:",
        tag: "Тег",
        addTag: "Добавить тег",
        removeTag: "Удалить тег",
        enterTag: "Введите тег",
        tagName: "Название тега",
        download: "Скачать",
        history: "История",
        detailed: "Детально",
        scale: "Масштаб",
        date: "Дата",
        selectDate: "Выбрать дату",
        selectTag: "Выбрать тег...",
        selectPeriod: "Выбрать период",
        close: "Закрыть",
        name: "Имя",
        edit: "Изменить",
        add: "Добавить",
        workerName: "Имя воркера",
        current: "Текущий",
        hashrate1h: "Хешрейт / 1ч",
        hashrate24h: "Хешрейт / 24ч",
        avgFor1h: "Среднее за 1ч",
        avgFor24h: "Среднее за 24ч",
        rejectRate24h: "Средний отказ / 24ч",
        rejectRate: "Процент отказов / 24ч",
        all: "Все",
        active: "Активные",
        inactive: "Неактивные",
        avgHashrate: "Средний хешрейт",
        rejectRateShort: "Процент отказов",
        connected: "Подключён",
        ipAddress: "IP адрес",
        infoLabel: "Инфо",
        lastShare: "Последний шер",
        allTags: "Все теги",
        minerTags: "Теги майнера",
        clickToAddTag: "(нажмите для добавления тега)",
        clickToRemoveTag: "(нажмите для удаления тега)",
    },

    // Курсы валют (вкладка «Обмен» в рейтинге)
    exchangeRates: {
        sourceImex: "IMEX",
        sourceOther: "Другие источники",
        sourceOtherHint: "Bybit и ЦБ РФ",
        sourceLabel: "Источник курсов",
        noImexData: "Курсы IMEX пока не собраны. Можно показать другие источники.",
        noData: "Курсов за этот период нет.",
        usdtRub: "USDT/RUB",
        derivedNote: "* расчётный курс: BTC/USDT × USDT/RUB (прямой пары BTC/RUB в этот день не было)",
        loading: "Загрузка…",
    },

    // Кошелёк
    wallet: {
        title: "Кошелёк",
        deposit: "Депозит",
        withdraw: "Вывод",
        withdrawal: "Вывести",
        exchange: "Обмен",
        swap: "Обмен токенов",
        walletAddress: "Адрес кошелька",
        enterWalletAddress: "Введите адрес кошелька",
        transferAmount: "Сумма перевода",
        enterAmount: "Введите сумму",
        max: "МАКС",
        min: "МИН",
        send: "ОТПРАВИТЬ",
        confirm: "ПОДТВЕРДИТЬ",
        securityVerification: "Проверка безопасности",
        confirmWithdrawal: "Подтверждение вывода",
        youGet: "Вы получите",
        expectedBTC: "Ожидается, BTC",
        totalPaidBTC: "Всего выплачено, BTC",
        history: "История",
        date: "Дата",
        copy: "Копировать",
        selectNetwork: "Выбрать сеть",
        type: "Тип",
        token: "Токен",
        status: "Статус",
        info: "Информация",
        networkFee: "Комиссия сети",
        networkMin: "Минимум сети",
        amount: "Сумма",
        tag: "Тег",
        enterTag: "Введите тег",
        priceBTC: "Цена BTC",
        available: "Доступно: {available} {coin}",
        availableLabel: "Доступно",
        swapFromTo: "Обмен {from} на {to}",
        swapError: "Не удалось выполнить обмен. Попробуйте ещё раз позже.",
        youWithdraw: "Вы выводите: {amount} {wallet}",
        toWalletAddress: "на кошелёк: {address} {addressTag} сеть: {network}",
        withdrawRub: "Вывести в ₽",
        rubWithdrawal: "Заявка на вывод в рублях",
        currentRate: "Текущий курс",
        noBankDetails: "Заполните банковские реквизиты в настройках профиля",
        rubRequests: "Мои заявки",
        requestSent: "Заявка принята. Мы свяжемся с вами.",
        statusPENDING: "Ожидает",
        statusPROCESSING: "В обработке",
        statusCOMPLETED: "Исполнено",
        statusFAILED: "Отклонено",
        depositType: "Зачисление",
        imexPendingBanner: "У вас есть незавершённый вывод через IMEX Custody. Завершите подтверждение:",
        imexPoolLiquidity: "Доступно в пуле (общая ликвидность IMEX, не личный баланс): {amount}",
        imexFrameTitle: "Подтверждение в IMEX Custody",
        imexFrameDescription: "Ваш запрос на вывод создан. Для завершения пройдите подтверждение в IMEX Custody.",
        imexFrameOpen: "Перейти к подтверждению",
        imexCancelWithdrawal: "Отменить вывод",
        imexCancelConfirm: "Вы уверены, что хотите отменить вывод?",
        imexCommission: "Комиссия IMEX",
        kucoinUsdt: "USDT (KuCoin)",
        withdrawUnavailable: "Вывод недоступен",
        networkLoadError: "Не удалось загрузить список сетей. Попробуйте позже.",
        depositAddressError: "Не удалось получить адрес для пополнения. Попробуйте позже.",
        withdrawRequestError: "Не удалось создать заявку на вывод. Попробуйте позже.",
    },

    // Дашборд
    dashboard: {
        income: "Доход",
        difficulty: "Сложность",
        totalPaid: "Всего выплачено, BTC",
        selectPeriod: "Выбрать период",
        bonus: "Бонус",
        vipPayrate: "VIP ставка",
        hashrate: "Хешрейт",
        hashrate24h: "Хешрейт 24ч",
        incomeBTC: "Доход, BTC",
        bonusBTC: "Бонус, BTC",
        rateSatTH: "Ставка, Sat/TH",
        total: "Всего",
        rateLabel: "Курс:",
        incomeRUB: "Сумма, ₽",
        rubPaid: "Выплачено, ₽",
        rubExpect: "Ожидается, ₽",
    },

    // Рейтинг
    rating: {
        title: "Рейтинг",
        pools: "Майнинг пулы",
        chart: "График",
        ratingPool: "Рейтинг / Пул",
        ratingInfo: "Рейтинг основан на реально работающем оборудовании, подключённом через анонимные аккаунты.",
        pool: "Пул",
        payrateLabel: "Выплата, SAT",
        payrateSmall: "выплата",
        addToChart: "Добавить в график",
        days: "{n} дней",
    },

    // Реферальная программа
    referral: {
        title: "Реферальная программа",
        referralId: "Реферальный ID",
        invite: "Пригласить",
        agentInfo: "Информация об агенте",
        becomeAgent: "Стать агентом",
        becomeReferral: "Стать рефералом",
        agentCode: "Введите код агента",
        referrals: "Рефералы",
        rank: "Ранг:",
        inviteCode: "Код приглашения:",
        name: "Имя",
        email: "Email",
        hashrate: "Хешрейт",
        incomeFee: "Комиссия с дохода, %",
        bonusFee: "Комиссия с бонуса, %",
        referralBonus: "Реферальный бонус, %",
        save: "Сохранить",
        bonus: "Бонус",
    },

    // Документы ФНС
    documents: {
        title: "Документы",
        incomeReport: "Справка о доходах от майнинга",
        incomeReportDesc: "Сформируйте отчёт о доходах за выбранный период. Документ подходит для подачи в ФНС, подготовки декларации 3-НДФЛ и бухгалтерской отчётности.",
        periodStart: "Начало периода",
        periodEnd: "Конец периода",
        placeholderStart: "01.01.2026",
        placeholderEnd: "31.12.2026",
        download: "Скачать PDF",
        downloadXml: "Скачать XML",
        generating: "Формируется...",
        error: "Не удалось сформировать документ. Попробуйте позже.",
        note: "Документ формируется на основе данных личного кабинета. Все суммы указаны в BTC на дату начисления.",
        miningTitle: "Отчет о майнинге цифровой валюты",
        miningDesc: "Кнопка подставляет в форму данные кабинета за выбранный месяц. Поля, которых в кабинете нет, остаются пустыми.",
        generate: "Сформировать отчет",
        year: "Отчетный год",
        month: "Отчетный месяц",
        correction: "Номер корректировки",
        taxOffice: "Код налогового органа",
        taxOfficeHint: "4 цифры, нужны для имени файла ФНС",
        energy: "Электроэнергия, кВт·ч",
        energyPh: "0.00",
        phone: "Номер телефона",
        email: "Адрес электронной почты",
        legalName: "Наименование",
        inn: "ИНН",
        kpp: "КПП",
        ogrn: "ОГРН",
        legalAddress: "Юридический адрес",
        operationType: "Тип операции",
        onPool: "Цифровая валюта находится на майнинг-пуле",
        credited: "Цифровая валюта зачислена на адрес-идентификатор",
        currency: "Цифровая валюта",
        minedAmount: "Размер добытой цифровой валюты",
        creditedAmount: "Размер зачисленной цифровой валюты",
        poolAddress: "Адрес-идентификатор майнинг-пула",
        creditAddress: "Адрес-идентификатор",
        watcher: "Watcher-link",
        equipment: "Сведения об оборудовании",
        worker: "Воркер",
        nominal: "Номинал, TH",
        brand: "Марка оборудования",
        model: "Модель оборудования",
        serial: "Заводской номер",
        hours: "Количество часов в эксплуатации",
        needValue: "Нет в кабинете",
        sectionMain: "Основные сведения",
        sectionContact: "Контактная информация",
        sectionLegal: "Реквизиты",
        sectionCurrency: "Сведения о цифровой валюте",
        addEquipment: "Добавить оборудование",
        missingNote: "Адрес пула берётся из настроек пула. Адрес зачисления можно сохранить здесь; если вывод уже был, подставляется последний.",
        creditSave: "Сохранить адрес",
        creditFromWithdrawal: "Подставлен адрес последнего вывода",
        stratumHours: "Часы по стратуму",
    },

    // Общее
    common: {
        showMore: "Показать ещё",
        loading: "Загрузка...",
        save: "Сохранить",
        cancel: "Отмена",
        delete: "Удалить",
        add: "Добавить",
        change: "Изменить",
        close: "Закрыть",
        copy: "Копировать",
        next: "Далее",
        send: "Отправить",
        confirm: "Подтвердить",
        select: "Выбрать",
        subscribe: "Подписаться на рассылку РУСБИТ",
        termsOfService: "Условия использования",
        iAgree: "Я прочитал и согласен с",
        passwordMust: "Пароль должен:",
    },
};
